import React from "react";
import SquareArrow from "./assets/square-arrow-right-up.svg";
import SquareArrowDownRed from "./assets/square-arrow-right-up-down-red.svg";
import classNames from "classnames";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";
import LandingTypography from "../../../../landingPage/pages/Homepage/components/LandingTypography";

export const ANALYSIS_FORMATION_VARIANTS = {
  HAMMER_UP: "hammer_up",
  HAMMER_DOWN: "hammer_down"
};

const AnalysisFormation = ({ variant, title, subtitle }) => {
  const isDesktop = useIsDesktop();

  let img;
  const imgProps = {
    alt: "Hammer",
    width: 40,
    height: 40,
    className: "shrink-0"
  };
  if (variant) {
    switch (variant) {
      case ANALYSIS_FORMATION_VARIANTS.HAMMER_UP:
        img = <img src={SquareArrow} {...imgProps} />;
        break;
      case ANALYSIS_FORMATION_VARIANTS.HAMMER_DOWN:
        img = (
          <img
            src={SquareArrowDownRed}
            {...imgProps}
            className={classNames("rotate-90", imgProps.className)}
          />
        );
        break;
    }
  }
  return (
    <LandingTypography className="flex flex-row items-start gap-3">
      {img}
      <div className="flex flex-col gap-1.5">
        {title ? (
          <strong
            className={classNames("font-semibold line-height-130 text-black", {
              "text-sm": !isDesktop,
              "text-base": isDesktop
            })}
          >
            {title}
          </strong>
        ) : null}
        {subtitle ? (
          <p
            className={classNames("line-height-100 text-black-8 mb-0", {
              "text-xs": !isDesktop,
              "text-sm": isDesktop
            })}
          >
            {subtitle}
          </p>
        ) : null}
      </div>
    </LandingTypography>
  );
};

export default AnalysisFormation;
